// frontend/src/utils/imgbb.js

const IMGBB_API_KEY = 'f7dd5a174e989f41ac0fbc93b49ecacc'; // ⚠️ Reemplaza con tu API key real

export const uploadToImgBB = async (file) => {
  try {
    const formData = new FormData();
    formData.append('image', file);

    const response = await fetch(`https://api.imgbb.com/1/upload?key=${IMGBB_API_KEY}`, {
      method: 'POST',
      body: formData
    });

    const data = await response.json();

    if (data.success) {
      return {
        success: true,
        url: data.data.url, // ✅ URL completa: https://i.ibb.co/xxx/imagen.png
        display_url: data.data.display_url,
        thumb: data.data.thumb?.url,
        delete_url: data.data.delete_url
      };
    } else {
      throw new Error(data.error?.message || 'Error al subir imagen');
    }
  } catch (error) {
    console.error('Error en uploadToImgBB:', error);
    return {
      success: false,
      error: error.message
    };
  }
};

export const uploadMultipleToImgBB = async (files) => {
  const results = [];
  for (const file of files) {
    const result = await uploadToImgBB(file);
    results.push(result);
  }
  return results;
};

// Función auxiliar para validar y corregir URLs
export const normalizeImageUrl = (url) => {
  if (!url) return null;
  
  // Si ya es una URL válida
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  
  // Si viene mal formada (sin https://), corregirla
  if (url.includes('i.ibb.co') || url.includes('imgbb')) {
    // Extraer la parte de la URL
    const match = url.match(/(https?:\/\/)?(i\.ibb\.co\/[^\s]+)/);
    if (match) {
      return `https://${match[2]}`;
    }
  }
  
  // Si empieza con /uploads, agregar el backend
  if (url.startsWith('/uploads')) {
    return `https://tuupastel-production.up.railway.app${url}`;
  }
  
  return url;
};
